class MetricsBody {
    /**
     *
     * @param {string} metricName
     * @param {"TIME" | "COUNTER"} type
     * @param {number} value
     */
    constructor(metricName, type, value) {
        this.metricName = metricName;
        this.type = type;
        this.value = value;
    }
}


export {MetricsBody};